module.exports = __webpack_public_path__ + "static/media/lastfm.d526e6b3.svg";